/** Common chrome for the menu sub-screens: a bakelite sheet with back button, heading, footer. */
import type { ReactNode } from 'react';
import { navStore } from '../../app/nav';
import { useT } from '../../i18n';
import { Button } from '../common/controls';
import s from './screens.module.css';

export function ScreenFrame({
  kicker,
  title,
  children,
  footer,
  right,
  width = 1240,
  onBack,
  backLabel,
  fit,
}: {
  /** Size the sheet to its content instead of filling the screen height. */
  fit?: boolean;
  kicker: ReactNode;
  title: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  /** Replaces the FRICTION wordmark on the right of the header. */
  right?: ReactNode;
  width?: number;
  onBack?: () => void;
  backLabel?: string;
}) {
  const t = useT();
  return (
    <div className={s.frame}>
      <div className={s.sheet} style={{ maxWidth: width, height: fit ? 'auto' : undefined }}>
        <header className={s.head}>
          <div className={s.headLeft}>
            <Button
              variant="ghost"
              icon="chevronLeft"
              hotkey="Esc"
              onClick={onBack ?? (() => navStore.getState().go('menu'))}
            >
              {backLabel ?? t('ui.back')}
            </Button>
          </div>
          <div className={s.heading}>
            <div className={s.kicker}>{kicker}</div>
            <h2 className={s.title}>{title}</h2>
          </div>
          {right ?? <div className={s.logo}>FRICTION</div>}
        </header>
        <div className={s.body}>{children}</div>
        {footer && <footer className={s.foot}>{footer}</footer>}
      </div>
    </div>
  );
}
